<template>
  <div class="wrap" v-if="!loading">
    <template v-if="!isEmpty">
      <div class="content">
        <div class="price"><span>¥</span>{{ showAmount }}</div>
      </div>
      <div class="pay-title">支付方式</div>
      <div class="pay-methods">
        <van-radio-group v-model="channel">
          <van-cell-group>
            <van-cell
              v-for="item in bankList"
              :key="item.agreementId"
              :title="item.fullName"
              clickable
              @click="channel = item.channel"
            >
              <template #right-icon>
                <van-radio :name="item.channel" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <div class="btn" @click="handlePay">去支付</div>
    </template>
    <template v-else>
      <div v-if="payStatus !== 'cancel'">
        <img class="icon" :src="icon" />
        <div class="pay-state">{{ showText }}</div>
      </div>
      <div v-else>
        <img class="icon" src="@/assets/images/jiaying-fail.png" />
        <div class="pay-state">订单状态为取消，不允许发起支付</div>
      </div>
    </template>
    <div class="server-icon" @click="handleServer"></div>
    <div class="footer">
      <p>会员费用由深圳市橡树黑卡网络科技有限公司收取</p>
      <p>
        客服电话：<a href="tel:400-620-9669">400-620-9669</a> ｜
        <a href="tel:400-150-9669">400-150-9669</a><span>(每日7:00-21:00)</span>
      </p>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  onMounted,
  computed,
} from "@vue/composition-api";
import Vue from "vue";
import qs from "qs";

import padding from "@/assets/images/jiaying-padding.png";
import { getJiayinPaymentInfo, jiayinPaymentPay } from "@/apis/jiayin";
import { useRoute, useStore, useRouter } from "@/components/use/base";
import { storage } from "@/utils";

const vm = Vue.prototype;

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const channel = ref("");
    const payChannel = ref();
    const amount = ref(0);
    const bankList = ref([]);
    const loading = ref(true);
    const isEmpty = ref(false);
    const deductType = ref("");
    const icon = ref(padding);
    const payStatus = ref("");

    const showText = computed(() => {
      return (
        {
          active: "支付结果处理中，请稍等",
          batch: "系统批扣支付结果处理中，请稍等",
        }[deductType.value] || ""
      );
    });

    const showAmount = computed(() => {
      return Number(amount.value).toFixed(2);
    });

    const initData = async () => {
      const fetching = vm.$loading();
      try {
        const res = await getJiayinPaymentInfo({
          orderId: store.state.orderId,
          indexList: route.query.indexList,
        });
        if (res.code === 200 && res.data.userBankList) {
          isEmpty.value = false;
          amount.value = res.data.amount;
          bankList.value = res.data.userBankList.map((item) => ({
            ...item,
            fullName: item.bankName + "(" + item.bankCardNo.slice(-4) + ")",
            channel: item.agreementId,
          }));
          if (bankList.value.length > 0) {
            channel.value = bankList.value[0].channel;
          }
        } else if (res.code === 201) {
          vm.$toast(res.msg);
          isEmpty.value = true;
        } else {
          isEmpty.value = true;
          deductType.value = res.data.deduct_type;
          payStatus.value = res.data.pay_status;
        }
      } finally {
        fetching.clear();
        loading.value = false;
      }
    };

    const handlePay = async () => {
      const fetching = vm.$loading();
      const payType = 1;
      const pageUrlParams = {
        orderId: store.state.orderId,
        pageUrl: route.query.pageUrl
          ? encodeURIComponent(route.query.pageUrl)
          : undefined,
        info: route.query.info,
        channelSource: route.query.channelSource,
      };
      try {
        const res = await jiayinPaymentPay({
          // 合作方回调地址
          partnerNotifyUrl: route.query.partnerNotifyUrl,
          orderId: store.state.orderId,
          indexList: route.query.indexList,
          payType,
          agreementId: channel.value,
          // 支付宝支付回跳地址
          pageCallUrl: encodeURIComponent(
            `${window.location.origin}/#/jiayinResult${qs.stringify(
              {
                user_token: storage.getItem("token"),
                namespace: store.state.namespace,
              },
              {
                addQueryPrefix: true,
              }
            )}`
          ),
        });
        if (res.code === 200) {
          if (payType === 1) {
            router.replace(
              `/jiayinResult${qs.stringify(
                {
                  ...pageUrlParams,
                  payOrderNumber: res.data.payOrderNumber,
                },
                {
                  addQueryPrefix: true,
                }
              )}`
            );
          } else {
            // todo 跳转支付宝h5
            location.replace(res.data.payUrl);
          }
        } else {
          vm.$toast(res.msg);
        }
      } finally {
        fetching.clear();
      }
    };
    onMounted(async () => {
      await initData();
    });

    const handleServer = () => {
      router.push("/help");
    };

    return {
      handlePay,
      handleServer,
      bankList,
      channel,
      payChannel,
      showAmount,
      loading,
      isEmpty,
      showText,
      icon,
      payStatus,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  padding: 0 12px;
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 40px;

  .server-icon {
    position: fixed;
    background: url(https://common-h5-dev.xiangshuheika.com/static/upload/202512106f7ba63458793.png);
    background-size: 100% 100%;
    width: 40px;
    height: 37px;
    top: 383px;
    right: 24px;
  }
}

.empty-wrap {
  margin: 0 auto;
  margin-top: 61px;
  width: 164px;

  img {
    width: 164px;
    height: 151px;
  }

  p {
    margin-top: 31px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    text-align: center;
  }
}

.content {
  margin-top: 37px;

  .price {
    font-weight: 600;
    font-size: 34px;
    color: #000000;
    line-height: 48px;
    text-align: center;

    span {
      font-size: 23px;
      margin-right: 5px;
    }
  }
  .name {
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 17px;
    text-align: center;
  }
}

.pay-title {
  font-weight: 400;
  font-size: 11px;
  color: #666666;
  line-height: 16px;
  margin-top: 38px;
  margin-bottom: 12px;
}

.pay-methods {
  /deep/ .van-radio-group {
    &:last-child {
      margin-top: 12px;
    }
  }
  /deep/ .van-cell-group {
    border-radius: 10px;
    overflow: hidden;
  }

  /deep/ .van-cell {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .item-name {
    color: #333333;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }

  .pay-item {
    display: flex;
    align-items: center;
    img {
      width: 22px;
      height: 22px;
      margin-right: 12px;
    }
  }
}

.h100 {
  height: 100px;
}

.btn {
  margin: 12px;
  height: 44px;
  font-weight: 500;
  font-size: 17px;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  background: linear-gradient(115deg, #4082e7 0%, #3254f2 100%);
  border-radius: 22px;
  margin-top: 32px;
}

.icon {
  height: 64px;
  width: 64px;
  display: block;
  margin: 0 auto;
  margin-top: 109px;
}

.pay-state {
  margin-top: 20px;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: center;
  margin-top: 20px;
}

.footer {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  p {
    font-weight: 400;
    font-size: 10px;
    color: #666666;
    line-height: 14px;
    text-align: center;

    &:last-child {
      color: #0170fe;
      margin-top: 12px;
    }
    span {
      margin-left: 8px;
      color: #666666;
    }
    a {
      color: #0170fe;
    }
  }
}

@supports (height: 100dvh) {
  .wrap {
    min-height: 100dvh;
  }
}
</style>
